import type { IDeviceInfo, TLocationSettingsType } from '../../../../types/tracking'
import { StatusIcon } from '../../status-icon'
import { DeviceInfoRow } from './shared'

interface HistoricalDeviceViewProps {
  device: IDeviceInfo | null
  driverName: string | null
  formattedLastSeen: string | null
  locationSettings: TLocationSettingsType | null
}

/**
 * The component that displays the historical device view
 */
export const HistoricalDeviceView = ({
  device,
  driverName,
  formattedLastSeen,
  locationSettings
}: HistoricalDeviceViewProps) => (
  <div className="flex flex-col gap-1 items-start">
    <DeviceInfoRow icon={<StatusIcon isPositive={!!driverName} />}>
      {driverName ? 'The driver is signed up for Chaine' : 'The driver is not signed up for Chaine'}
    </DeviceInfoRow>

    <DeviceInfoRow icon={<StatusIcon isPositive={false} />}>
      The driver has not opened the app to accept tracking
    </DeviceInfoRow>

    <div className="pt-4">
      <span className="text-foreground">
        A tracking link was sent to {driverName ? driverName : 'the driver'} with instructions on{' '}
        {driverName ? 'how to start tracking.' : 'how to download the app.'}{' '}
        {device?.deviceManufacturer || device?.devicePlatform
          ? `${driverName ? driverName : 'The driver'} was last seen ${formattedLastSeen} using a ${
              device?.deviceManufacturer || device?.devicePlatform
            }
              ${device?.deviceModel}/ OS ${device?.deviceOSVersion || device?.androidSDKVersion} with ${
                locationSettings?.authorizationStatus
              } permissions.`
          : `Once ${
              driverName ? driverName : 'the driver'
            } opens the app, you will be able to see their device information and locations.`}
      </span>
    </div>
  </div>
)
